module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/otwarcie/thumbs/2-37d7719681507381b657525239db1e7b.webp";